import BaseModel from 'src/model/base.model';

import AddressModel from './address.model';
import LocationModel from './location.model';

interface IPaymentMethods {
  method: string;
  active: boolean;
}

class UserModel extends BaseModel {
  public sub: string = '';
  public accountId: string = '';
  public specialUser: string = '';
  public userId: string = '';
  public name: string = '';
  public country: string = '';
  public permission: any[] = [];
  public tokenExpiration: number = 0;
  public tokenEmittedIn: number = 0;
  public accountCredit: {
    balance: string;
    creditLimit: string;
    creditStatus: string;
    currency: string;
  };
  public address: AddressModel;
  public billingAddress: AddressModel;
  public clientIdentity: string;
  public email: string;
  public mobileNumber: string;
  public warehouseInfo: LocationModel;
  public defaultMannerOfTransport: string;
  public pickup: boolean;
  public ponumberRequired: boolean;
  public paymentMethods: IPaymentMethods[];
  public partsmartUsername: string = '';
  public partsmartEmail: string = '';
  public isDelivery: boolean;
  public creditStopCode: string;
  public mobileValid: boolean;
  public emailValid: boolean;
  public userValidationEligible: boolean;  
  public emailSkipCount: number;
  public emailValidSkipCount: number;
  public specialUserEmail: string = '';
}

export default UserModel;
